import { FC, PropsWithChildren, ReactNode } from "react";
import { Card } from "shared/components/Card";
import { Show } from "shared/components";
import { type SwitchProps } from "shared/components/forms/Switch";
import { useTemplateContext } from "../provider";
import { SwitchWithReadOnlyMode } from "../SwitchWithReadOnlyMode";

interface Props {
  title: string;
  rightElement?: ReactNode;
  switchProps?: SwitchProps;
}

export const ConfigurableCard: FC<PropsWithChildren<Props>> = ({
  title,
  rightElement,
  switchProps,
  children
}) => {
  const { readOnly } = useTemplateContext();

  return (
    <Card className="p-8 space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-base font-bold text-content-1000">{title}</p>
        <Show if={rightElement}>{rightElement}</Show>
      </div>
      {switchProps ? (
        <SwitchWithReadOnlyMode
          checked={switchProps.checked}
          label={switchProps.label}
          onChange={switchProps.onChange}
          disabled={switchProps.disabled}
          readOnly={readOnly}
        />
      ) : null}
      <Show if={children}>{children}</Show>
    </Card>
  );
};
